import {
    instance
} from '../../util/http'
import apis from '../../config/apis'

const getPackages = (id) => {
    return instance.get(apis.Package.Get + "?packageid=" + id)
}
// 打包一口价 type 3
const checkoutPackage = (packageData) => {
    return instance.post(apis.Package.Post, packageData)
}
const list = (page, limit) => {
    return instance.get(apis.Package.List + "?Page=" + page + "&Limit=" + limit)
}

export default {
    getPackages,
    checkoutPackage,
    list
}